import React from 'react';
import is from 'is_js';
import { Icon } from 'omni-common-ui';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from './style.postcss';

export const ScoreStar = (props) => {
  const { fullMark, currentResult } = props;
  const level = getLevelByPercentage(percentage(currentResult, fullMark));
  return <div className={classnames(styles.ScoreStar, props.className)}>
    {renderStarsByLevel(level)}</div>;
};


function fraction(value = 0, max) {
  if (is.number(max)) {
    return value / max;
  }

  if (value > 100) {
    value = 100;  // eslint-disable-line
  }

  return value / 100;
}

function clamp(fract) {
  return Math.min(1,
    Math.max(0, fract)
  );
}

function percentage(value, max) {
  return Math.round(
    clamp(
      fraction(value, max)
    ) * 100
  );
}

function getLevelByPercentage(percent) {
  if (percent >= 1 && percent < 30) return 1;
  else if (percent >= 30 && percent < 60) return 2;
  else if (percent >= 60 && percent < 70) return 3;
  else if (percent >= 70 && percent < 80) return 4;
  else if (percent >= 80 && percent <= 100) return 5;
  return 0;
}

function calcStarNumberByLevel(level) {
  if (level === 0) {
    return 0;
  }
  return (level / 2) + 0.5;
}

function renderStarsByLevel(level) {
  const stars = [];
  const starNumber = calcStarNumberByLevel(level);
  const starFullNumber = parseInt(starNumber, 10);

  for (let i = 0; i < 3; i++) {
    if (i < starFullNumber) {
      stars.push(<Icon className={styles.ScoreStar_starIcon} key={`star-full${i}`} id="star-full" />);
    } else if (i === starFullNumber && starNumber % 1 !== 0) {
      stars.push(<Icon className={styles.ScoreStar_starIcon} key={`star-half${i}`} id="star-half" />);
    } else {
      stars.push(<Icon className={styles.ScoreStar_starIcon} key={`star-empty${i}`} id="star-empty" />);
    }
  }
  return stars;
}

ScoreStar.propTypes = {
  className: PropTypes.string,
  currentResult: PropTypes.number,
  fullMark: PropTypes.number,
};

export default ScoreStar;



// WEBPACK FOOTER //
// ./containers/Group/ProgressReport/StudentReportView/ScoreStar/index.jsx